import React from 'react';
import {connect} from 'react-redux';

import Product from '../Product';
import Spacer from './Spacer';

const Body = ({id, title, products, productID}) => (
    <tbody id={`product-category-${id}`} className="product-category" data-title={title}>
        {products.map(product => <Product {...product} current={product.id === productID} key={product.id} />)}
        <Spacer />
    </tbody>
);

const mapStateToProps = ({productID}) => ({productID});

export default connect(mapStateToProps)(Body);
